export default "__VITE_ASSET__Jsm2ykYU__"